// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TfBG","col":"styles_col__2M95v"};